import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MarqueeBanner from "@/components/MarqueeBanner";
import PricingPackages from "@/components/PricingPackages";
import BeforeAfterGallery from "@/components/BeforeAfterGallery";
import HowItWorks from "@/components/HowItWorks";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";

function App() {
  const [booking, setBooking] = useState({ open: false, pkg: null });
  const openBooking = (pkg = null) => setBooking({ open: true, pkg });

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#0B0D10] text-slate-100 min-h-screen font-jakarta antialiased" data-testid="app-root">
      <Header onBook={() => openBooking()} />
      <main>
        <Hero onBook={() => openBooking()} />
        <MarqueeBanner />
        <PricingPackages onBook={openBooking} />
        <BeforeAfterGallery />
        <HowItWorks onBook={() => openBooking()} />
        <FAQSection />
      </main>
      <Footer />
      <BookingModal
        open={booking.open}
        initialPackage={booking.pkg}
        onClose={() => setBooking({ open: false, pkg: null })}
      />
    </div>
  );
}

export default App;
